// Minimal RFC-4180 CSV parser (quoted fields, escaped quotes, CRLF).
export const parseCsv = (text) => {
  const rows = [];
  let row = [], cell = "", q = false;
  const s = text.replace(/^\uFEFF/, "");
  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    if (q) {
      if (c === '"' && s[i + 1] === '"') { cell += '"'; i++; }
      else if (c === '"') q = false;
      else cell += c;
    } else if (c === '"') q = true;
    else if (c === ",") { row.push(cell); cell = ""; }
    else if (c === "\n" || c === "\r") {
      if (c === "\r" && s[i + 1] === "\n") i++;
      row.push(cell); rows.push(row); row = []; cell = "";
    } else cell += c;
  }
  if (cell || row.length) { row.push(cell); rows.push(row); }
  return rows.filter((r) => r.some((x) => x.trim()));
};

const HEADERS = {
  name: ["business", "business name", "name"], type: ["type"],
  street: ["street address", "street"], city: ["city"], state: ["state"], zip: ["zip code", "zip", "zipcode", "postal code"],
  address: ["address", "full address"], phone: ["phone"], website: ["website"], email: ["email"],
  contact_person: ["contact", "contact person", "contact name"], zone_number: ["zone #", "zone number"],
  status: ["status"], notes: ["notes"], last_contacted: ["last contacted"], latitude: ["latitude", "lat"], longitude: ["longitude", "lng", "lon"],
};

export const TEMPLATE_HEADERS = ["Business", "Type", "Street Address", "City", "State", "Zip Code", "Phone", "Website", "Email", "Contact", "Zone #", "Status", "Notes", "Last Contacted"];

// Returns {rows, matched:[header labels], missingName:boolean}
export const csvToProspectRows = (text) => {
  const [head = [], ...body] = parseCsv(text);
  const idx = {};
  head.forEach((h, i) => {
    const k = Object.keys(HEADERS).find((f) => HEADERS[f].includes(h.trim().toLowerCase()));
    if (k && idx[k] === undefined) idx[k] = i;
  });
  const rows = body.map((r) => Object.fromEntries(Object.entries(idx).map(([k, i]) => [k, (r[i] || "").trim()])));
  return { rows, matched: head.filter((h, i) => Object.values(idx).includes(i)), missingName: idx.name === undefined };
};
